export const forgotPasswordChanged = () => {
  return {
    title: 'Contraseña Cambiada Exitosamente',
    subtitle_1: 'Haga clic en el enlace a continuación e inicie sesión con sus nuevas credenciales',
    log_in: 'Iniciar Sesión'
  }
}
